class ComparativoScripts {
	constructor() {
        ( function ( $ ) {
            "use strict";
            if ($('#comparar-produtos').length) {
                $('.gaia_comparar').on('click', function(){
                    $(this).addClass('loading');

                    let produtos_selecionados = { produtos: [] };
                    if ($('.product-compare').length) {
                        produtos_selecionados.produtos.push(`${$('.product-compare').data('id')}`);
                    }
                    const selecionados = HSSelect.getInstance('#gaia_products_compare').value;
                    if (selecionados.length > 0) {
                        selecionados.forEach(element => {
                            produtos_selecionados.produtos.push(`${element}`);
                        });
                        // produtos = produtos.concat(selecionados);
                    } else if (!$('.product-compare').length && selecionados.length == 0) {
                        alert(t('comparativo.select_at_least_two_products'));
                        $(this).removeClass('loading');
                        return;
                    } else {
                        alert(t('comparativo.select_at_least_one_product'));
                        $(this).removeClass('loading');
                        return;
                    }

                    let queryString = $.param(produtos_selecionados);
                    console.log(queryString);
                    let newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + queryString;

                    setTimeout(function() {
                        window.location.href = newUrl;
                    }, 1500);
                });
            }
        }( jQuery ) );
    }
}

export default ComparativoScripts